// extracted by mini-css-extract-plugin
module.exports = {"manualEditorContainer":"DrumsManualEditor_manualEditorContainer__v9zeZ","shimmer":"DrumsManualEditor_shimmer__3ybe7"};